// extracted by mini-css-extract-plugin
export default {"payPeriod-header":"Header_payPeriod-header__Paam3","payPeriod-header-item":"Header_payPeriod-header-item__P5jD1"};